export const CLEAR_PREVIOUS_REDUCERS = "CLEAR_PREVIOUS_REDUCERS";

export const FETCH_ALL_DEALER = "FETCH_ALL_DEALER";
export const FETCH_ALL_DEALER_SUCCESS = "FETCH_ALL_DEALER_SUCCESS";
export const FETCH_ALL_DEALER_FAILED = "FETCH_ALL_DEALER_FAILED";

export const FETCH_COUNTRY = "FETCH_COUNTRY";
export const FETCH_COUNTRY_SUCCESS = "FETCH_COUNTRY_SUCCESS";
export const FETCH_COUNTRY_FAILED = "FETCH_COUNTRY_FAILED";

export const FETCH_STATE = "FETCH_STATE";
export const FETCH_STATE_SUCCESS = "FETCH_STATE_SUCCESS";
export const FETCH_STATE_FAILED = "FETCH_STATE_FAILED";

export const FETCH_CITY = "FETCH_CITY";
export const FETCH_CITY_SUCCESS = "FETCH_CITY_SUCCESS";
export const FETCH_CITY_FAILED = "FETCH_CITY_FAILED";

export const CREATE_BRANCH = "CREATE_BRANCH";
export const CREATE_BRANCH_SUCCESS = "CREATE_BRANCH_SUCCESS";
export const CREATE_BRANCH_FAILED = "CREATE_BRANCH_FAILED";

export const FETCH_SINGLE_DEALER = "FETCH_SINGLE_DEALER";
export const FETCH_SINGLE_DEALER_SUCCESS = "FETCH_SINGLE_DEALER_SUCCESS";
export const FETCH_SINGLE_DEALER_FAILED = "FETCH_SINGLE_DEALER_FAILED";

export const FETCH_DEALER_BRANCH = "FETCH_DEALER_BRANCH";
export const FETCH_DEALER_BRANCH_SUCCESS = "FETCH_DEALER_BRANCH_SUCCESS";
export const FETCH_DEALER_BRANCH_FAILED = "FETCH_DEALER_BRANCH_FAILED";

export const FETCH_COUNTRY_BRANCH = "FETCH_COUNTRY_BRANCH";
export const FETCH_COUNTRY_BRANCH_SUCCESS = "FETCH_COUNTRY_BRANCH_SUCCESS";
export const FETCH_COUNTRY_BRANCH_FAILED = "FETCH_COUNTRY_BRANCH_FAILED";

export const FETCH_STATE_BRANCH = "FETCH_STATE_BRANCH";
export const FETCH_STATE_BRANCHSUCCESS = "FETCH_STATE_BRANCHSUCCESS";
export const FETCH_STATE_BRANCHFAILED = "FETCH_STATE_BRANCHFAILED";

export const FETCH_CITY_BRANCH = "FETCH_CITY_BRANCH";
export const FETCH_CITY_BRANCHSUCCESS = "FETCH_CITY_BRANCHSUCCESS";
export const FETCH_CITY_BRANCHFAILED = "FETCH_CITY_BRANCHFAILED";
